import { FC } from 'react'
import styles from './menu-item.module.scss'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import { useRouter } from 'next/router'
import classNames from '@/utils/helpers/class-names.helper'
import isCurrentPathEqualsHref from '@/utils/helpers/current-path-equals-href.helper'
import useI18nPath from '@/hooks/i18n-path.hook'

type MenuItemProps = {
  path: string
  i18Name: string
}

const MenuItem: FC<MenuItemProps> = ({ path, i18Name }) => {
  const { t } = useTranslation()
  const { getHrefLang } = useI18nPath()
  const router = useRouter()

  return (
    <li className={styles.item}>
      <Link
        itemProp="url"
        className={classNames(
          styles.link,
          isCurrentPathEqualsHref(router.asPath, path) && styles._active
        )}
        href={getHrefLang(path)}
        dangerouslySetInnerHTML={{ __html: t(i18Name) }}
      >
        {/* {t(i18Name)} */}
      </Link>
    </li>
  )
}

export default MenuItem
